export default num => {
  return +num.toFixed(2);
};
